import { Component, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

const noop = () => {};

@Component({
  selector: 'app-ald-applicant-comment',
  templateUrl: './ald-applicant-comment.component.html',
  styleUrls: ['./ald-applicant-comment.component.css'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => AldApplicantCommentComponent), multi: true }],
})
export class AldApplicantCommentComponent implements OnInit {
  ngOnInit(): void {
    if (this.maxLength == null || this.maxLength == undefined) this.maxLength = 500;
  }

  // private comment: any = '';

  //   // inputs
  // @Input() requestApplicantComment: string;

  constructor() {}
  //The internal data model
  private innerValue: any = '';

  @Input() type: string = 'text';
  @Input() placeholder: any = '';
  @Input() maxLength: number = 250;
  @Input() minLength: number = 0;
  @Input() min: number = 0;
  @Input() max: number = 10;
  @Input() isReadOnly: boolean = false;
  @Input() tabIndex: number = null;
  @Input() isDisabled = false;
  @Input() isRequired = false;
  @Input() label: string;

  @Output()
  onBlur = new EventEmitter<string>();

  @Output()
  onChange = new EventEmitter<string>();

  //Placeholders for the callbacks which are later provided
  //by the Control Value Accessor
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  //get accessor
  get value(): any {
    if (this.innerValue) {
      return this.innerValue.trim();
    }

    return this.innerValue;
  }

  //set accessor including call the onchange callback
  set value(v: any) {
    if (v !== this.innerValue) {
      if (v) {
        this.innerValue = v.toString().trim();
      } else {
        this.innerValue = v;
      }

      this.onChangeCallback(this.innerValue);
    }
  }

  //Set touched on blur
  onBlurFn() {
    this.onBlur.emit(this.value);
    this.onTouchedCallback();
  }

  //Set touched on change
  onChangeFn() {
    this.onChange.emit(this.value);
  }

  //From ControlValueAccessor interface
  writeValue(value: any) {
    if (value !== this.innerValue) {
      if (value) {
        this.innerValue = value.toString().trim();
      } else {
        this.innerValue = value;
      }
    }
  }

  //From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  checkSpecialChar(key) {
    key.value = key.value.replace(/[!$%^&*()_+|~=`{}\[\]";'<>?.\/]/g, '');
  }
}
